// @ts-nocheck
// /about — "מי אני" (Shlomo's text, edited 10.10.2026 in
// marketing/דף אודות המחבר - טיוטה 9.10.docx). Linked from /pick's footer.
// Photos (11.10): public/about/*.jpg, prepared from marketing/תמונות.

import { useEffect } from "react";
import { logSiteEvent } from "../lib/siteEvents";

const styles = `
.ab-wrap { max-width: 680px; margin: 0 auto; padding: 0 16px 48px; direction: rtl; font-family: 'Heebo', sans-serif; color: #2D1B10; }
.ab-band { background: linear-gradient(135deg, #5C3D2E, #7a5238); color: #fff; text-align: center; padding: 20px 16px 16px; margin: 0 -16px 18px; }
.ab-band h1 { font-family: 'Frank Ruhl Libre', serif; font-size: 28px; font-weight: 700; margin: 0; line-height: 1.15; }
.ab-band h2 { font-family: 'Frank Ruhl Libre', serif; font-size: 16px; font-weight: 700; margin: 6px 0 0; color: #F0C27B; }
.ab-p { font-size: 15.5px; line-height: 1.75; margin: 0 0 14px; }
.ab-p b { font-family: 'Frank Ruhl Libre', serif; color: #5C3D2E; font-size: 17px; }
.ab-photo { width: 100%; border-radius: 14px; margin: 4px 0 16px; display: block; }
.ab-portrait { max-width: 300px; margin: 0 auto 18px; }
.ab-links { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 18px; }
.ab-links a { text-decoration: none; border-radius: 10px; padding: 10px 14px; font-size: 14px; font-weight: 700; color: #fff; background: linear-gradient(135deg, #A0704A, #D4875A); }
.ab-links a.q { background: #5C3D2E; }
.ab-foot { text-align: center; font-size: 12.5px; color: #8B7355; margin-top: 20px; }
`;

export function AboutPage() {
  useEffect(() => {
    logSiteEvent("about_view");
  }, []);
  return (
    <div className="ab-wrap">
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="ab-band">
        <h1>שלמה אלפנבוים</h1>
        <h2>מי אני</h2>
      </div>

      <img className="ab-photo ab-portrait" src="/about/shlomo.jpg" alt="שלמה אלפנבוים" />

      <p className="ab-p">
        למעלה מעשרים שנה אני מנחה סדנאות אינטליגנציה רגשית בארגונים: חברות הייטק, אל על, אגד, צה"ל, התנדבויות (20 שנה) בעמותת "אחרי", בבתי ספר, ובארגונים נוספים.
      </p>

      <p className="ab-p">
        בכל אחת מהסדנאות היה אותו רגע שמישהו הבין פתאום שהכעס שלו, או הפחד ליתר דיוק, הוא תגובה אמיתית לסכנה מדומיינת שלא קיימת, ואחרי ההבנה הזו החיים כבר השתנו. הרגע הזה הוא הסיבה לכתיבת הספר.
      </p>

      <p className="ab-p">
        <b>האריות.</b> יום אחד (יותר נכון שבוע אחד) רכבתי על סוס בסוואנה שבדלתא של האוקוונגו, בבוצואנה שהיא מעל דרום אפריקה. לקראת שבע בערב, בדרך חזרה למאהל, הפתיעו אותנו שני אריות שרבצו בעשב כעשרים מטר מאיתנו. המדריך לחש: לעמוד. לא לזוז. לא להוציא מצלמה. הגוף שלי ידע בדיוק מה לעשות, בלי לשאול אותי. זו מערכת ההישרדות, והיא מצוינת מול אריות. הבעיה היא שהיא עובדת באותה עוצמה גם בפקק, במייל מהבוס, בטון של בן הזוג, בהתנהגות של הילדים. מכאן נולדה השאלה בת שלוש המילים שאני מלמד: יש כאן אריה?
      </p>

      <p className="ab-p">
        <b>הבית.</b> אני ונורית 47 שנים יחד, 3 ילדים, 5 נכדים, והזוגיות, לא תאמינו, הולכת ומשתפרת. כן, גם אותנו זה מפתיע. הסוד, אם יש כזה: הקשבה. נדמה לי שאני מקשיב יותר והיא מדברת יותר. תשאלו אותה, היא תגיד בדיוק את אותו הדבר, רק הפוך. ומהבית הזה יצא שבט שלם, ילדים ונכדים, שמדברים ככה זה עם זה. מה שלימדתי בסדנאות הוא מה שקורה אצלנו במטבח.
      </p>

      <img className="ab-photo" src="/about/nurit-shlomo.jpg" alt="שלמה ונורית" />
      <img className="ab-photo" src="/about/family.jpg" alt="כל המשפחה" />

      <p className="ab-p">
        <b>הספר.</b> בשלב מסוים חשתי רצון עז להוציא את הסדנה מהחדר. לא לכתוב עליה, לבנות אותה מחדש כך שאפשר לעבור אותה לבד, בבית, בקצב שלך: לקרוא או להקשיב, מדי פעם גם לעצור ולכתוב. הפיתוח הדיגיטלי נעשה בסיוע בינה מלאכותית (קלוד קוד ומערכות עזר נוספות), לאורך שנה, ובסוף ביקשתי מקלוד לראיין אותי (11 דקות, הקישור למטה). יצאו 12 מפגשים. קוראים להם "שאלת האריה - סדנה בספר", ואפשר להתחיל מאיזה פרק שרוצים.
      </p>

      <p className="ab-p">
        <b>מה אני לא.</b> לא פסיכולוג ולא רופא. אני מנחה. עברתי לאורך השנים המון לימודים מסוגים שונים וסדנאות שנושאיהן קשורים עמוק לעיסוק שלי: CBT, בודהיזם, NLP, פסיכולוגיה חיובית, הדרכת רכיבה, מנהיגות בשטח, רטוריקה, מנטורים, וכמובן כמה סדנאות בהנחיה של אינטליגנציה רגשית. הסדנאות הראשונה והשנייה היו בארגון 6 Seconds מקליפורניה.
      </p>

      <p className="ab-p">
        אני לא מגדיר את עצמי כמטפל אלא כמנחה באינטליגנציה רגשית. מה שאני כן יודע זה איך להביא אדם רגיל לרגע שבו הוא עוצר לשלוש שניות לפני שהמילים המיותרות יוצאות, והוא לא מדחיק אותן, הוא מבין שהן שגויות ומיותרות.
      </p>

      <p className="ab-p">זה כל מה שהספר הזה מבקש.</p>

      <div className="ab-links">
        <a className="q" href="https://youtu.be/Kk-RakpOzow" target="_blank" rel="noreferrer">הראיון עם קלוד (11 דקות)</a>
        <a href="/pick">לבחור פרק</a>
        <a className="q" href="/contact">יצירת קשר</a>
      </div>

      <div className="ab-foot">שאלת האריה - סדנה בספר · eiforall.com</div>
    </div>
  );
}
